export enum SloState {
  Success = 'success',
  Fail = 'fail',
  NotAvailable = 'n/a',
}
